export const SITE_DOCUMENT_DETAIL_QUERY_KEY = 'siteDocumentDetail';
export const SITE_DOCUMENT_INVITES_QUERY_KEY = 'siteDocumentInvites';
